export default __webpack_public_path__ + "static/media/251.eb961866.jpg";